import TableEntry from '../TableEntry';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'baseui';
import { ProductService } from '../../../../../../frameworks_drivers/redux/reducers/onboardingInformation';

const CenteredSubContent = styled('div', {
  fontSize: '0.875rem',
  lineHeight: '1.25rem'
});

const FinalPriceTag = styled('p', {
  color: `#007c94!important`,
  lineHeight: '32px'
});

interface TotalPriceProps {
  numberOfApartments: number;
  selectedProducts: ProductService[];
}

const sumPrice = (selectedProducts: ProductService[]): number => {
  if (selectedProducts.length === 0) {
    return 0;
  }
  return selectedProducts.map((item) => item.price).reduce((prev, current) => prev + current, 0);
};

const TotalPrice: React.FC<TotalPriceProps> = ({ numberOfApartments, selectedProducts }) => {
  const { t } = useTranslation();

  const sumPriceFormatted = useMemo(() => {
    const formatPrice = (price?: number) => {
      if (!price || price <= 0) {
        return t('freePriceText');
      }
      const localPrice = price!.toLocaleString('de-DE', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      });
      return t('fullPriceText', { priceTerm: localPrice });
    };

    return formatPrice(sumPrice(selectedProducts));
  }, [selectedProducts, t]);

  return (
    <TableEntry
      leftValues={[
        t('pageSummaryPriceSectionLabelTotalPrice', {
          priceTerm: t('pageSummaryPriceSectionLabelPriceTerm'),
          numberOfApartments: numberOfApartments
        }),
        <CenteredSubContent key="sub-content" className="py-2">
          {t('pageSummaryPriceSectionSublabelTotalPrice')}
        </CenteredSubContent>
      ]}
      endElement={
        <FinalPriceTag className="m-0 fs-4 fw-semibold" data-gi="price-tag">
          {sumPriceFormatted}
        </FinalPriceTag>
      }
    />
  );
};

export default TotalPrice;
